import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Convertit un chemin d'image local en URL utilisable
 */
export function getProductImageUrl(localPath: string | null): string {
  if (!localPath) {
    return "/placeholder-product.png";
  }

  // Si c'est déjà une URL complète
  if (localPath.startsWith("http")) {
    return localPath;
  }

  // Chemin local: images/product_1077/image1.webp
  // On le sert via l'API route
  return `/api/images/${localPath.replace("images/", "")}`;
}

/**
 * Convertit une valeur de prix (string ou number) en nombre
 * PostgreSQL retourne les DECIMAL comme strings
 */
export function toNumber(value: string | number | null | undefined): number | null {
  if (value === null || value === undefined) {
    return null;
  }
  const num = typeof value === "string" ? parseFloat(value) : value;
  return isNaN(num) ? null : num;
}

/**
 * Formate un prix avec 2 décimales (gère string ou number)
 */
export function formatPriceValue(price: string | number | null | undefined): string {
  const num = toNumber(price);
  if (num === null) {
    return "0.00";
  }
  return num.toFixed(2);
}

/**
 * Formate un prix en euros
 */
export function formatPrice(price: string | number | null | undefined): string {
  const num = toNumber(price);
  if (num === null) {
    return "Sur devis";
  }
  return new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency: "EUR",
  }).format(num);
}

/**
 * Formate un prix HT avec mention
 */
export function formatPriceHT(price: string | number | null | undefined): string {
  const num = toNumber(price);
  if (num === null) {
    return "Sur devis";
  }
  return `${num.toFixed(2)} € HT`;
}

/**
 * Génère un slug à partir d'un texte
 */
export function slugify(text: string): string {
  return text
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)+/g, "");
}
